// see:
// https://github.com/module-federation/module-federation-examples/tree/master/dynamic-system-host
// https://webpack.js.org/plugins/module-federation-plugin
// https://webpack.js.org/concepts/module-federation/

import { getOrLoadRemote } from './getOrLoadRemote';
import { SharedModule } from './types';

/**
 * This does two things. First it makes sure the URL is loaded and available.
 * Then it will extract a `module` out of it and returns it.
 */
export function loadComponent<T extends object>(
  /**
   * This should be the same as the 'name' property that is set in the client
   * ModuleFederation plugin.
   */
  remote: string,

  /**
   * This should match one of the keys in the `exposes` map that is defined in
   * the clients ModuleFederation plugin.
   */
  module: string,

  /** The URL of the remoteEntry.js file to load */
  url: string,
): () => Promise<{ default: T }> {
  return async () => {
    await getOrLoadRemote(remote, url);
    const container: SharedModule = global[remote];
    const factory = await container.get<T>(module);
    const Module = factory();
    return Module;
  };
}
